import { render } from "./500.vue?vue&type=template&id=8bbaf674"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src28501298/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__